export default {"src":"/_next/static/media/manaw.04fda44f.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};